import { type ReactNode, useMemo } from 'react';

import { useCardOfferPublisherContext } from '@/microfrontends/listing/shared/context/selectors/cardData';

import { memoWithDisplayName } from '@/packages/react-utils/memoWithDisplayName';

import { DocumentsChecked } from '../DocumentsChecked';
import { LinkToPublisherProfile } from '../LinkToPublisherProfile';
import { PublisherLevelView } from '../PublisherLevelView';

type PublisherNameWithBadgesProps = {
  type: 'compact' | 'full';
};

export const PublisherNameWithBadges = memoWithDisplayName<PublisherNameWithBadgesProps>(props => {
  const { type } = props;

  const publisher = useCardOfferPublisherContext();
  const { extendedProperties: { workHonestly, documentsCheckedLabel } = {} } = publisher;

  const badges = useMemo<Array<ReactNode>>(
    () =>
      Array.of<ReactNode>(
        !!workHonestly && <PublisherLevelView key="publisherLevelView" level={workHonestly.level} />,
        type === 'compact' && !!documentsCheckedLabel && (
          <DocumentsChecked text={documentsCheckedLabel} type="tooltip" />
        ),
      ),
    [documentsCheckedLabel, type, workHonestly],
  );

  return (
    <LinkToPublisherProfile
      as={type === 'compact' ? 'UIHeading5' : 'UIHeading4'}
      badges={badges}
      publisher={publisher}
      withTextOverflowEllipsis={type === 'compact'}
    />
  );
}, 'PublisherNameWithBadges');
